import { render, staticRenderFns } from "./BbsLayout.vue?vue&type=template&id=84c5dcb2&scoped=true"
import script from "./BbsLayout.vue?vue&type=script&lang=js"
export * from "./BbsLayout.vue?vue&type=script&lang=js"
import style0 from "./BbsLayout.vue?vue&type=style&index=0&id=84c5dcb2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c5dcb2",
  null
  
)

export default component.exports